import axios from 'axios';

export type ClaimStatus = 'Open' | 'Pending' | 'Closed';

const Claims = {
	async getClaims() {
		return await axios({
			method: 'GET',
			url: process.env.VUE_APP_API_URI + '/claims',
		});
	},
	async saveClaimData(claimData) {
		return await axios({
			method: 'POST',
			url: process.env.VUE_APP_API_URI + '/claims',
			data: claimData,
		});
	},
	async notifyClaimFilesUploaded(claimId) {
		return await axios({
			method: 'GET',
			url: process.env.VUE_APP_API_URI7 + '/claimfiles/' + claimId,
		});
	},
	async updateClaimDataWithClaimFormUrl(fileName, fileLocation, uploadUrl, claimId) {
		return await axios({
			method: 'POST',
			url: process.env.VUE_APP_API_URI + '/claims',
			data: {
				cmd: 'updateClaimDataWithClaimFormUrl',
				fname: fileName,
				fileLocation,
				upload_url: uploadUrl,
				claimId,
			},
		});
	},
	async savePublicClaimData(claimData) {
		return await axios({
			method: 'POST',
			url: process.env.VUE_APP_API_URI7 + '/public-claims',
			data: claimData,
		});
	},
	async getPresignedUrls(fileLog) {
		return await axios({
			method: 'POST',
			url: process.env.VUE_APP_API_URI + '/claims/upload',
			data: {
				files: fileLog,
			},
		});
	},
	async getPublicPresignedUrls(fileLog) {
		return await axios({
			method: 'POST',
			url: process.env.VUE_APP_API_URI7 + '/public-claims/upload',
			data: {
				files: fileLog,
			},
		});
	},
	async uploadFiles(signedUrl, file, config) {
		const request = {
			method: 'PUT',
			url: signedUrl,
			headers: {
				'Content-Type': file.type,
			},
			skipAuth: true,
			processData: true,
			data: file,
			...config,
		};
		return await axios(request);
	},

	getClaimStatus(claim): ClaimStatus {
		if (claim.claim_status !== 'CLOSED') {
			if (claim.real_claim_id) {
				return 'Open';
			}

			if (!claim.real_claim_id) {
				return 'Pending';
			}
		} else {
			return 'Closed';
		}
	},
};

export default Claims;
